<template>
  <div class="animated fadeIn">
    <div class="container" v-bind:class="{ spinner: isBusy }">
      <div v-if="!isBusy">
        <span v-if="!surveyInstances">{{ $t("Webportal.NoDataFoundPlain") }}</span>

        <b-card class="mb-3" v-for="surveyInstance in surveyInstances" :key="surveyInstance.SurveyInstanceId">
          <template v-slot:header>
            <h5>{{ $t("Webportal.CheckInfo") }}</h5>

            <survey-improvement-header class="pt-2" :surveyInstance="surveyInstance" />
          </template>

          <b-form-group>
            <b-button v-if="surveyInstance.CanCreateSurveyImprovementForExternalAccess" :disabled="surveyInstance.SurveyInstance.SurveyInstanceStatusId < 215 ||
              surveyInstance.SurveyInstance.SurveyInstanceStatusId >= 300" variant="primary" size="sm"
              @click="createSurveyImprovement(surveyInstance)">
              <font-awesome-icon :icon="['fas', 'comment-exclamation']" size="lg" />&nbsp;
              {{ $t("Webportal.Actions.SurveyImprovement.Create") }}
            </b-button>
          </b-form-group>

          <span v-if="!surveyInstance.SurveyImprovements" class="font-weight-light">
            {{ $t("Webportal.Actions.NoSurveyImprovementsFound") }}
          </span>

          <div v-else>
            <p v-if="$te('Webportal.Actions.SurveyImprovement.StatusLinkHint')">
              <span class="text-danger">
                <font-awesome-icon :icon="['fas', 'info-circle']" />
                {{ $t('Webportal.Actions.SurveyImprovement.StatusLinkHint') }}
              </span>
            </p>

            <div class="d-flex flex-wrap">
              <survey-improvement-card v-for="surveyImprovement in surveyInstance.SurveyImprovements"
                :key="surveyImprovement.SurveyImprovementId" :surveyImprovement="surveyImprovement"
                to="ExternalSurveyImprovement" />
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/services/EventBus.js";
import SurveyImprovementHeader from "@/components/Action/SurveyImprovementHeader";
import SurveyImprovementCard from "@/components/Action/SurveyImprovementCard";
import ActionService from "@/services/ActionService";
import SurveyImprovementMixin from "@/mixins/SurveyImprovementMixin";

export default {
  name: "SurveyImprovements",

  mixins: [SurveyImprovementMixin],

  components: {
    SurveyImprovementHeader,
    SurveyImprovementCard,
  },

  data() {
    return {
      isBusy: false,

      surveyInstances: null,
    };
  },

  created() {
    this.getSurveyInstances();
    EventBus.$on("LocalizationChanged", this.localizationChanged);
  },

  beforeUnmount() {
    EventBus.$off("LocalizationChanged", this.localizationChanged);
  },

  methods: {
    localizationChanged(localizationId) {
      this.getSurveyInstances();
    },

    getSurveyInstances() {
      this.isBusy = true;

      return ActionService.getSurveyInstances()
        .then((response) => {
          this.surveyInstances = response.data.items;
        })
        .finally((_) => {
          this.isBusy = false;
        });
    },

    createSurveyImprovement(surveyInstance) {
      this.$router.push({ name: 'ExternalSurveyImprovement', query: { sid: surveyInstance.SurveyInstance.SurveyInstanceId } })
    },
  },
};
</script>
